import { Component } from '@angular/core';


export class SkyPageSummaryDemoComponent {
  public name = 'Robert C. Hernandez';
  public showAlert = true;
  public showImage = true;
  public showTitle = true;
  public showSubtitle = true;
  public showStatus = true;
  public showContent = true;
  public showKeyInfo = true;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-page-summary-demo',
  template: `<div style="border: solid 1px #ccc">
  <sky-page-summary>
    <sky-page-summary-alert *ngIf="showAlert">
      <sky-alert alertType="info">This is an alert.</sky-alert>
    </sky-page-summary-alert>
    <sky-page-summary-image *ngIf="showImage">
      <sky-avatar [name]="name" [canChange]="true"></sky-avatar>
    </sky-page-summary-image>
    <sky-page-summary-title *ngIf="showTitle">
      {{name}}
    </sky-page-summary-title>
    <sky-page-summary-subtitle *ngIf="showSubtitle">
      Board member
    </sky-page-summary-subtitle>
    <sky-page-summary-status *ngIf="showStatus">
      <sky-label labelType="success">Fundraiser</sky-label>
      <sky-label>Inactive</sky-label>
    </sky-page-summary-status>
    <sky-page-summary-content *ngIf="showContent">
      This is the arbitrary content section. You can display any kind of content to complement the
      content on a page. We recommend that you display content to support the key tasks of users of
      users who visit the page. We also recommend that you keep in mind the context of how users
      will use the content and limit the amount of content to avoid overloading the summary.
    </sky-page-summary-content>
    <sky-page-summary-key-info *ngIf="showKeyInfo">
      <sky-key-info>
        <sky-key-info-value>The key information</sky-key-info-value>
      </sky-key-info>
      <sky-key-info>
        <sky-key-info-value>section highlights</sky-key-info-value>
      </sky-key-info>
      <sky-key-info>
        <sky-key-info-value>important details</sky-key-info-value>
      </sky-key-info>
    </sky-page-summary-key-info>
  </sky-page-summary>
</div>

<ul class="sky-list-unstyled">
  <li>
    <sky-checkbox [(ngModel)]="showTitle">
      <sky-checkbox-label>Show title</sky-checkbox-label>
    </sky-checkbox>
  </li>
  <li>
    <sky-checkbox [(ngModel)]="showSubtitle">
      <sky-checkbox-label>Show subtitle</sky-checkbox-label>
    </sky-checkbox>
  </li>
  <li>
    <sky-checkbox [(ngModel)]="showImage">
      <sky-checkbox-label>Show image</sky-checkbox-label>
    </sky-checkbox>
  </li>
  <li>
    <sky-checkbox [(ngModel)]="showStatus">
      <sky-checkbox-label>Show record status</sky-checkbox-label>
    </sky-checkbox>
  </li>
  <li>
    <sky-checkbox [(ngModel)]="showKeyInfo">
      <sky-checkbox-label>Show key information</sky-checkbox-label>
    </sky-checkbox>
  </li>
  <li>
    <sky-checkbox [(ngModel)]="showContent">
      <sky-checkbox-label>Show arbitrary content</sky-checkbox-label>
    </sky-checkbox>
  </li>
  <li>
    <sky-checkbox [(ngModel)]="showAlert">
      <sky-checkbox-label>Show alert</sky-checkbox-label>
    </sky-checkbox>
  </li>
</ul>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
